import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Every named type size in the theme (`tailwind.config.ts` →
 * `theme.extend.fontSize`). tailwind-merge only knows Tailwind's own sizes
 * (`text-sm`, `text-xs`…) and reads any other `text-<word>` as a colour, so
 * without this list `cn('text-meta', 'text-ink-500')` dropped the 12px size.
 * A test keeps this list equal to the config's keys (T-0192).
 */
export const THEME_FONT_SIZES = [
  'display',
  'h1',
  'h2',
  'h3',
  'body',
  'body-sm',
  'meta',
  'mono-sm',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...THEME_FONT_SIZES] }],
    },
  },
});

/**
 * shadcn/ui convention: merge `clsx` conditional class lists with
 * `tailwind-merge` deduplication so callers can write
 *   `cn('p-2 rounded', isActive && 'bg-primary', overrideClass)`
 * and get the right cascade-aware result. A named size and a text colour
 * never collide: `cn('text-meta', 'text-ink-500')` keeps both.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Join class lists without tailwind-merge's de-duplication (plain `clsx`). */
export { clsx as cx } from 'clsx';
